
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';
import { getCustomerListHoutai, getCustomerList } from '@/api/customer';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'customerDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  customerVisible!: Boolean;
  @Prop({
    type: Boolean,
    default: false
  })
  isCheckbox!: Boolean;

  @Prop({
    type: Boolean,
    default: true
  })
  isShowModal?: Boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  editData!: any;

  @Prop({
    type: Array,
    default: () => ([])
  })
  selectCustomer!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  customerIsImportOrder?: Boolean;

  @Prop({
    type: Number,
    default: 1
  })
  type?: number;
  // 1 默认 2 添加下级 3项目选择(04.01 获取所有客户，查看客户群组 改成这样的)

  private listQuery = {
    name: '',
    address: [],
    page: 1
  };

  private listData: any = {
    more: false,
    customerList: []
  };

  private loading = false;
  private moreLoading = false;
  private radioSelected = '';
  private lAreaData!: any;
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private selectAreaBean: any = {};

  private selectedAll = false;
  private isIndeterminate: any = null;
  private checkboxSelected: any = [];
  private checkboxSelectedId: any = [];
  private selectedDynamicTags: any = [];

  // 全选
  private handleCheckAllChange(val: boolean) {
    this.dealData(val, this.checkboxSelectedId, this.listData.customerList, 0);
    this.isIndeterminate = false;
  }
  // 单个checkBox 选中
  private handleCheckChange(checked: any, val: any, lv:any, lv1:any, lv2:any) {
    if (checked) {
      this.checkboxSelected.push(val);
    } else {
      this.checkboxSelected.splice(this.checkboxSelected.indexOf(val), 1);
    }
    let p = [];
    p.push(val);
    this.dealData(checked, this.checkboxSelectedId, p, 0);
    this.lvSelect(checked, lv, this.checkboxSelected);
    this.lvSelect(checked, lv1, this.checkboxSelected);
    this.lvSelect(checked, lv2, this.checkboxSelected);
  }
  // 选中下级选上级
  private lvSelect(checked:any, lv:any, checkboxSelected:any) {
    if (checked && lv) {
      let arr = checkboxSelected.filter((ss:any) => {
        return (parseInt(lv.customer_user_id) !== 0 && ss.customer_user_id === lv.customer_user_id) || (parseInt(lv.customer_company_id) !== 0 && ss.customer_company_id === lv.customer_company_id);
      });
      if (!arr || arr.length < 1) {
        if (parseInt(lv.customer_type) === 1) {
          this.checkboxSelectedId.push(lv.customer_company_id);
        } else {
          this.checkboxSelectedId.push(lv.customer_user_id);
        }

        this.checkboxSelected.push(lv);
      }
    }
  }
  // 增加数据
  private pushData(check: any, list: any, val: any) {
    let id = '';
    if (parseInt(val.customer_type) === 1) {
      id = val.customer_company_id;
    } else {
      id = val.customer_user_id;
    }
    let index = list.indexOf(id);
    if (check) {
      if (index === -1) {
        this.checkboxSelected.push(val);
        this.checkboxSelectedId.push(id);
      }
    } else {
      if (index !== -1) {
        list.splice(index, 1);
        this.checkboxSelected.splice(index, 1);
      }
    }
  }

  // 递归数组 把所有选中的子集设置为选中
  private dealData(check: any, options: any, list: any, n: any) {
    n++;
    if (n > 5) {
      return;
    }
    for (let i = 0; i < list.length; i++) {
      this.pushData(check, options, list[i]);
      if (list[i].child) {
        this.dealData(check, options, list[i].child, n);
      }
    }
  }

  // 计算所有项 长度
  private getAllLength(length: any, list: any, n: any) {
    n++;
    if (n > 5) {
      return;
    }
    if (list && list.length > 0) {
      length += list.length;
      for (let i = 0; i < list.length; i++) {
        length = this.getAllLength(length, list[i].child, n);
      }
    }
    return length;
  }

  // 底下全部选中 上方全选选中
  private handleCheckedSelectedChange(val: any) {
    let checkedCount = val.length;
    let _length = this.getAllLength(0, this.listData.customerList, 0);
    this.selectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }

  private closeTagHandle(val: any) {
    this.checkboxSelected.splice(this.checkboxSelected.indexOf(val), 1);
    if (parseInt(val.customer_type) === 1) {
      this.checkboxSelectedId.splice(this.checkboxSelected.indexOf(val.customer_company_id), 1);
    } else {
      this.checkboxSelectedId.splice(this.checkboxSelected.indexOf(val.customer_user_id), 1);
    }

    let _len = this.getAllLength(0, this.listData.customerList, 0);
    this.selectedAll = this.checkboxSelected.length === _len; // 客户总条数
    this.isIndeterminate =
      this.checkboxSelected.length > 0 &&
      this.checkboxSelected.length < _len;
  }

  private nextHandle() {
    if (this.checkboxSelected.length > 0) {
      this.$emit('selectcusnext', this.checkboxSelected);
    } else {
      this.$notify({
        title: '警告',
        message: '请选择客户',
        type: 'warning'
      });
    }
  }

  created() {
    this.getCustomerList('', '', '');
    // if (this.editData && (this.editData as any).customerList) {
    //   this.checkboxSelected = (this.editData as any).customerList;
    // }
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item &&
          item.child &&
          item.child.map((temp: any) => {
            if (temp && temp.child && temp.child.length === 0) {
              (temp.child as any) = undefined;
            }
          });
      }
    });
  }
  resetData() {
    this.listQuery.name = '';
    this.listQuery.address = [];
    this.listQuery.page = 1;
    this.listData = {
      more: false,
      customerList: []
    };

    this.checkboxSelected = [];
    this.radioSelected = '';
    this.selectedAll = false;
  }
  close() {
    this.$emit('close', false);
  }
  moreCusData() {
    this.moreLoading = true;
    this.listQuery.page += 1;
    this.getCustomerList('', '', '');
  }

  load(tree:any, treeNode:any, resolve:any) {
    this.getCustomerList(tree.customer_company_id, tree, resolve);
  }

  getCustomerList(pid:any, tree:any, resolve:any) {
    this.loading = true;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      name: this.listQuery.name,
      page: this.listQuery.page,
      address: this.listQuery.address
    };
    if (pid) {
      params.customer_company_pid = pid;
      params.size = 999999;
    }
    if (this.type !== 3) {
      params.is_order = 1;
    }

    // if (this.type === 2) {
    // params.customer_company_pid = 0;
    // params.customer_type = 1;
    if (this.type === 2) {
      params.customer_type = 1;
      params.is_order = 0;
    }
    params.customer_name = this.listQuery.name;
    getCustomerList(params).then((res:any) => {
      if (pid) {
        if (res.data && res.data.list) {
          let dataTable:any = res.data.list;
          tree.child = dataTable;
          dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
          resolve(dataTable);
        } else {
          resolve([]);
        }
      } else {
        if (res.data === null || (res.data && res.data.page_count <= this.listQuery.page)) {
          this.listData.more = false;
        } else {
          this.listData.more = true;
        }
        if (res.data && res.data.list) {
          res.data.list.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
          if (this.listQuery.page === 1) {
            this.listData.customerList = res.data.list;
          } else {
            this.listData.customerList = this.listData.customerList.concat(res.data.list);
          }
          this.checkSelect(this.listData.customerList);
        }
      }
      this.loading = false;
      this.moreLoading = false;
    }).catch((err:any) => {
      this.loading = false;
      this.moreLoading = false;
      let msg = err.msg;
      // this.showErrorMsg(err.msg);
    });
    // } else {
    //   getCustomerListHoutai(params).then((res:any) => {
    //     if (res.data === null || (res.data && res.data.page_count <= this.listQuery.page)) {
    //       this.listData.more = false;
    //     } else {
    //       this.listData.more = true;
    //     }
    //     if (res.data && res.data.list) {
    //       if (pid) {
    //         let dataTable:any = res.data.list;
    //         tree.children = dataTable;
    //         dataTable.forEach((item:any) => {
    //           (item as any).hasChildren = parseInt(item.lower_count) > 0;
    //         });
    //         resolve(dataTable);
    //       } else {
    //         if (this.listQuery.page === 1) {
    //           this.listData.customerList = res.data.list;
    //         } else {
    //           this.listData.customerList = this.listData.customerList.concat(res.data.list);
    //         }
    //         this.checkSelect(this.listData.customerList);
    //       }
    //     }
    //     this.loading = false;
    //     this.moreLoading = false;
    //   }).catch((err:any) => {
    //     this.loading = false;
    //     this.moreLoading = false;
    //     this.showErrorMsg(err.msg);
    //   });
    // }
  }

  private checkSelect(list:any) {
    let selectData ;
    if(this.editData && this.editData.customerList){
      selectData = this.editData.customerList;
    }
    if(this.selectCustomer && this.selectCustomer.length>0){
      selectData = this.selectCustomer;
    }
    if ( selectData.length > 0) {
      for (let i = 0; i < selectData.length; i++) {
        let item: any = selectData[i];
        if (parseInt(item.customer_type) === 1) {
          let arr = this.checkboxSelected.filter((v: any) => {
            return v.customer_company_id === item.customer_company_id;
          });
          if (!arr || arr.length < 1) {
            this.checkboxSelectedId.push(item.id);
            this.checkboxSelected.push(item);
          }
        } else {
          let arr = this.checkboxSelected.filter((v: any) => {
            return v.customer_user_id === item.customer_user_id;
          });
          if (!arr || arr.length < 1) {
            this.checkboxSelectedId.push(item.id);
            this.checkboxSelected.push(item);
          }
        }
        // for (let m = 0; m < list.length; m++) {
        //   let element: any = list[m];
        //   if (parseInt(element.customer_type) === 1) {
        //     if (element.customer_company_id === item.customer_company_id) {
        //       let arr = this.checkboxSelected.filter((v: any) => {
        //         return v.customer_company_id === item.customer_company_id;
        //       });
        //       if (!arr || arr.length < 1) {
        //         this.checkboxSelected.push(element);
        //       }
        //     }
        //   } else {
        //     if (element.customer_user_id === item.customer_user_id) {
        //       let arr = this.checkboxSelected.filter((v: any) => {
        //         return v.customer_user_id === item.customer_user_id;
        //       });
        //       if (!arr || arr.length < 1) {
        //         this.checkboxSelected.push(element);
        //       }
        //     }
        //   }
        //   if (element.child) {
        //     this.checkSelect(element.child);
        //   }
        // }
      }
      if (this.checkboxSelected.length === this.listData.customerList.length) {
        this.selectedAll = true;
        this.isIndeterminate = false;
      }
      // this.$emit('checkedCustomerChange', this.checkboxSelected);
    }
  }

  selectedCustomerResult() {
    if (this.radioSelected === '') {
      this.$notify({
        title: '提示',
        message: '请选择客户',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return;
    }
    this.$emit('selectresult', this.radioSelected);
    if (!this.customerIsImportOrder) {
      this.close();
    }
  }
  clearButton() {
    this.resetData();
    this.getCustomerList('', '', '');
  }
  searchData() {
    this.listQuery.page = 1;
    this.listData = {
      more: false,
      customerList: []
    };
    this.getCustomerList('', '', '');
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
